/* TT Kurv-skuffe */
(function () {
  var root = document.getElementById('tt-cd');
  if (!root) return;

  document.body.appendChild(root);
  root.style.zIndex = '2147483000';

  var st = document.createElement('style');
  st.textContent = [
    '.tt-cd__head{flex-direction:row-reverse;justify-content:flex-end;gap:14px;padding:14px 18px}',
    '.tt-cd__head h2{font-family:var(--font-body-family);font-size:13px;font-weight:600;letter-spacing:.2em;text-transform:uppercase}',
    '.tt-cd__x{margin:0 0 0 -10px}',
    '.tt-cd__item{grid-template-columns:96px minmax(0,1fr);gap:16px}',
    '.tt-cd__img{position:relative;display:block;width:96px;height:124px;overflow:hidden}',
    '.tt-cd .tt-cd__img img{position:absolute;top:6px;left:6px;right:6px;bottom:6px;width:calc(100% - 12px);height:calc(100% - 12px);max-width:none;max-height:none;object-fit:contain;object-position:center;margin:0}',
    '.tt-cd__foot{display:flex;flex-wrap:wrap;align-items:center;column-gap:10px}',
    '.tt-cd__total{flex:1 1 auto;min-width:0;align-items:center;gap:8px}',
    '.tt-cd__sums{display:flex;align-items:baseline;gap:8px;white-space:nowrap}',
    '.tt-cd__sums s{margin:0}',
    '.tt-cd__sums b{font-size:24px;line-height:1}',
    '.tt-cd__savebadge{margin:0;flex:none}',
    '.tt-cd__savebadge span{white-space:nowrap}',
    '.tt-cd__pay,.tt-cd__paylist,.tt-cd__terms,.tt-cd__hint{flex:1 0 100%}',
    '.tt-cd__pay{margin-top:12px}',
    '@media (max-width:749px){',
    '.tt-cd__panel{max-width:100%;box-shadow:none}',
    '.tt-cd__head{padding:8px 14px;gap:10px}',
    '.tt-cd__head h2{font-size:12px}',
    '.tt-cd__x{width:40px;height:40px;margin-left:-8px}',
    '.tt-cd__x svg{width:22px;height:22px}',
    '.tt-cd__progress{padding:8px 14px}',
    '.tt-cd__msg{font-size:12.5px;margin:0 0 6px}',
    '.tt-cd__bar{height:3px}',
    '.tt-cd__tier{font-size:11.5px;margin-top:5px}',
    '.tt-cd__items{padding:0 14px}',
    '.tt-cd__item{grid-template-columns:84px minmax(0,1fr);gap:12px;padding:12px 0}',
    '.tt-cd__img{width:84px;height:108px}',
    '.tt-cd__name{font-size:17px;padding-right:30px}',
    '.tt-cd__badge{font-size:9.5px;padding:2px 6px;margin-top:4px}',
    '.tt-cd__unit{font-size:12px;margin-top:4px}',
    '.tt-cd__row{margin-top:8px}',
    '.tt-cd__qty{height:34px}',
    '.tt-cd__qty button{width:34px;font-size:16px}',
    '.tt-cd__qty span{min-width:24px;font-size:13px}',
    '.tt-cd__line{font-size:14px}',
    '.tt-cd__rm{width:26px;height:26px;top:10px}',
    '.tt-cd__rm svg{width:12px;height:12px}',
    '.tt-cd__perks{margin:12px 14px 14px;gap:6px}',
    '.tt-cd__reward{grid-template-columns:34px minmax(0,1fr) auto;gap:10px;padding:8px 10px}',
    '.tt-cd__ricon{width:34px;height:34px}',
    '.tt-cd__ricon svg{width:18px;height:18px}',
    '.tt-cd__rtxt b{font-size:13px}',
    '.tt-cd__rtxt small{font-size:11.5px}',
    '.tt-cd__rval{font-size:11.5px}',
    '.tt-cd__foot{padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));column-gap:8px}',
    '.tt-cd__total{font-size:13px;gap:6px}',
    '.tt-cd__sums{gap:6px}',
    '.tt-cd__sums s{font-size:12px}',
    '.tt-cd__sums b{font-size:20px}',
    '.tt-cd__savebadge span{font-size:10.5px;padding:3px 7px}',
    '.tt-cd__pay{min-height:50px;margin-top:10px;font-size:11px}',
    '.tt-cd__paylist{margin-top:8px;gap:4px}',
    '.tt-cd__paylist svg{height:16px}',
    '}'
  ].join('');
  document.head.appendChild(st);

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('tt-cd-config').textContent); } catch (e) {}
  var T = cfg.t || {};
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (id) { return document.getElementById(id); };
  var accept = $('tt-cd-accept');
  var panel = root.querySelector('.tt-cd__panel');
  var pay = $('tt-cd-pay');
  var RX_ADD = new RegExp('/cart/add');
  var RX_CART = new RegExp('/cart/?$');
  var openedAt = 0;

  function money(c) {
    var v = c / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' kr';
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 500);
  }
  function isOpen() { return root.classList.contains('is-open'); }

  function open() {
    openedAt = Date.now();
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tt-cd-lock'); document.documentElement.classList.add('tt-cd-active');
    setTimeout(function () { panel.focus(); }, 50);
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tt-cd-lock');
    panel.style.transform = '';
  }
  root.querySelectorAll('[data-tt-cd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  document.addEventListener('pointerdown', function (e) {
    if (!isOpen() || Date.now() - openedAt < 300) return;
    if (panel.contains(e.target)) return;
    e.preventDefault();
    close();
  }, true);

  var sx = 0, sy = 0, dx = 0, swiping = false;
  panel.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; swiping = true; }, { passive: true });
  panel.addEventListener('touchmove', function (e) {
    if (!swiping) return;
    dx = e.touches[0].clientX - sx;
    var dy = Math.abs(e.touches[0].clientY - sy);
    if (dx > 10 && dx > dy) { panel.style.transition = 'none'; panel.style.transform = 'translateX(' + dx + 'px)'; }
  }, { passive: true });
  panel.addEventListener('touchend', function () {
    swiping = false; panel.style.transition = '';
    if (dx > 90) close(); else panel.style.transform = '';
  });

  function render(cart) {
    var items = cart.items || [];
    var th = cfg.threshold || 0;
    var total = cart.total_price;
    var orig = cart.original_total_price || cart.items_subtotal_price;
    var saved = Math.max(0, orig - total);

    var msg = $('tt-cd-msg'), bar = $('tt-cd-bar');
    if (th > 0) {
      var rest = th - total;
      msg.innerHTML = rest > 0 ? esc(T.missing).replace('[beløb]', '<b>' + money(rest) + '</b>') : esc(T.unlocked);
      bar.style.width = Math.min(100, total / th * 100) + '%';
    }

    var qty = cart.item_count, tierTxt = '';
    var tiers = (cfg.tiers || []).filter(function (t) { return t[1] > 0; }).sort(function (a, b) { return a[0] - b[0]; });
    for (var i = 0; i < tiers.length; i++) {
      if (qty < tiers[i][0]) {
        var diff = tiers[i][0] - qty;
        tierTxt = (T.tier || '').replace('[antal]', diff).replace('[pct]', tiers[i][1]);
        if (diff === 1) tierTxt = tierTxt.replace(' flasker ', ' flaske ');
        break;
      }
    }
    if (!tierTxt && tiers.length && qty >= tiers[tiers.length - 1][0]) tierTxt = T.tierDone || '';
    $('tt-cd-tier').textContent = items.length ? tierTxt : '';

    var list = $('tt-cd-items');
    list.innerHTML = items.map(function (it, idx) {
      var disc = (it.line_level_discount_allocations || []).map(function (a) { return a.discount_application && a.discount_application.title; }).filter(Boolean);
      var unitOrig = it.original_price, unitFinal = Math.round(it.final_line_price / it.quantity);
      var price = unitFinal < unitOrig ? '<s>' + money(unitOrig) + '</s><b>' + money(unitFinal) + '</b>' : '<b>' + money(unitOrig) + '</b>';
      var src = it.image ? '<img src="' + esc(img(it.image, 500)) + '" alt="" loading="lazy" decoding="async">' : '';
      return '<li class="tt-cd__item" data-line="' + (idx + 1) + '">' +
        '<a class="tt-cd__img" href="' + esc(it.url) + '">' + src + '</a>' +
        '<div><a class="tt-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (disc.length ? '<span class="tt-cd__badge">' + esc(disc[0]) + '</span>' : '') +
        '<div class="tt-cd__unit">' + price + ' / fl.</div>' +
        '<div class="tt-cd__row"><div class="tt-cd__qty"><button type="button" data-q="-1" aria-label="Færre">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Flere">+</button></div>' +
        '<span class="tt-cd__line">' + money(it.final_line_price) + '</span></div></div>' +
        '<button type="button" class="tt-cd__rm" data-rm aria-label="' + esc(T.remove) + ' ' + esc(it.product_title) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</li>';
    }).join('');

    var rw = $('tt-cd-reward'), unlocked = th > 0 && total >= th;
    rw.hidden = !items.length || th <= 0;
    rw.classList.toggle('is-open', unlocked);
    $('tt-cd-rsub').textContent = unlocked ? (T.open || '') : (T.locked || '').replace('[beløb]', money(th));
    $('tt-cd-rval').innerHTML = unlocked ? T.free + (cfg.shipping > 0 ? '<s>' + money(cfg.shipping) + '</s>' : '') : '';

    $('tt-cd-sum').textContent = money(total);
    $('tt-cd-orig').textContent = saved > 0 ? money(orig) : '';
    var sv = $('tt-cd-save');
    sv.hidden = saved <= 0;
    sv.innerHTML = saved > 0 ? '<span>' + esc((T.save || '').replace('[beløb]', money(saved))) + '</span>' : '';

    $('tt-cd-empty').hidden = !!items.length;
    $('tt-cd-foot').hidden = !items.length;
    $('tt-cd-progress').hidden = !items.length || th <= 0;

    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (bubble) bubble.textContent = cart.item_count;
  }

  function load() {
    root.classList.add('is-loading');
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; })
      .finally(function () { root.classList.remove('is-loading'); });
  }
  function change(line, quantity) {
    root.classList.add('is-loading');
    return fetch(base + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(render).finally(function () { root.classList.remove('is-loading'); });
  }

  $('tt-cd-items').addEventListener('click', function (e) {
    var li = e.target.closest('.tt-cd__item'); if (!li) return;
    var line = parseInt(li.dataset.line, 10);
    var q = parseInt(li.querySelector('.tt-cd__qty span').textContent, 10);
    var b = e.target.closest('[data-q]');
    if (b) { change(line, Math.max(0, q + parseInt(b.dataset.q, 10))); return; }
    if (e.target.closest('[data-rm]')) change(line, 0);
  });

  function syncTerms() { root.classList.toggle('terms-pending', !!accept && !accept.checked); if (accept && accept.checked) $('tt-cd-hint').hidden = true; }
  if (accept) accept.addEventListener('change', syncTerms);
  syncTerms();
  if (pay) pay.addEventListener('click', function (e) {
    if (accept && !accept.checked) { e.preventDefault(); $('tt-cd-hint').hidden = false; accept.focus(); }
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"]');
    if (!a || root.contains(a)) return;
    if (RX_CART.test(window.location.pathname)) return;
    e.preventDefault(); load(); open();
  });

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (RX_ADD.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(function () { load().then(open); }, 150); }).catch(function () {});
    }
    return p;
  };

  window.TTCartDrawer = { open: function () { load(); open(); }, close: close, refresh: load };
})();